import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './LoginForm.jsx'

export default createSubmit(name)